import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import portalGetStarted from "@/components/portal-get-started.vue";
import portalLogin from "@/components/portal-login.vue";
import portalPersonalInfo from "@/components/portal-personal-info.vue";
import portalSystemPage from "@/components/portal-system-page.vue";
const routes = [
  {
    path: "/",
    name: "get-started",
    component: portalGetStarted,
  },
  {
    path: "/login",
    name: "login",
    component: portalLogin,
  },
  {
    path: "/user",
    meta: { AuthRequired: true },
    children: [
      {
        path: "/user/system-pages",
        name: "system-pages",
        component: portalSystemPage,
      },
      {
        path: "/user/personal-info",
        name: "personal-info",
        component: portalPersonalInfo,
      },
    ],
  },

  {
    path: "/testimonial/bap",
    name: "testimonial-bap",
    component: () => import("@/components/contents/borlio-feedback.vue"),
  },
  {
    path: "/testimonial/yong",
    name: "testimonial-yong",
    component: () => import("@/components/contents/yong-feedback.vue"),
  },
  {
    path: "/testimonial/jinnah",
    name: "testimonial-jinnah",
    component: () => import("@/components/contents/jinnah-feedback.vue"),
  },
  {
    path: "/testimonial/edjec",
    name: "testimonial-edjec",
    component: () => import("@/components/contents/edjec-feedback.vue"),
  },
  {
    path: "/testimonial/ian",
    name: "testimonial-ian",
    component: () => import("@/components/contents/ian-feedback.vue"),
  },
  {
    path: "/testimonial/mark",
    name: "testimonial-mark",
    component: () => import("@/components/contents/mark-feedback.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  let user = store.state.user;
  if (to.matched.some((record) => record.meta.AuthRequired)) {
    if (!user) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
